<template>
  <div class="about">
    <div>关于我们ZTY/FMJ (该页面采用静态资源，首次加载会比较慢，请耐心等待^_^~~~~)</div>
  </div>
  <div class="iframe_box">
    <iframe width="100%" height="1000px" src="static/about.html" frameborder="0" scrolling="auto" ref="iframeDom"></iframe>
  </div>
</template>